const peritaspurple = {
  50: '#ececfc',
  100: '#cfd1f7',
  200: '#aeb2f1',
  300: '#8b91ea',
  400: '#6a72e5',
  500: '#4652e2',
  600: '#3d47cf',
  700: '#3138b8',
  800: '#262ba1',
  900: '#171a7d',
  a100: '#cfd1f7',
  a200: '#8b91ea',
  a400: '#4652e2',
  a700: '#3138b8',
};

const peritasnavy = '#121b2a';
const peritasviolet = '#901de4';
const workflowPink = '#e53284';

const peritasgrey = {
  25: '#fafbfc',
  40: '#ebeced',
  50: '#efefef',
  100: '#d6d9d9',
  200: '#b8c0c3',
  300: '#99a7ad',
  400: '#81949b',
  500: '#6a828a',
  600: '#5e7279',
  700: '#4e5e64',
  800: '#404b4f',
  900: '#2f3638',
  a100: '#d6d9d9',
  a200: '#b8c0c3',
  a400: '#81949b',
  a700: '#4e5e64',
};

const periversePalette = {
  peritaspurple,
  peritasnavy,
  peritasviolet,
  peritasgreen: '#4add00',
  background: {
    default: '#f7f9fa',
    paper: '#ffffff',
  },
  tag: {
    neutral: '#e4e5e6',
  },
  ink: '#141414',
  /**
   * Body copy, mapping to the design system's `text/primary` and
   * `text/secondary`. Deliberately not `peritasnavy` (#121b2a), which is a
   * surface colour — the design uses a lighter, bluer navy for type.
   */
  text: {
    primary: '#1d2a40',
    secondary: 'rgba(29, 42, 64, 0.7)',
  },
  border: {
    subtle: '#dbe4ee',
  },
  shadows: {
    timeline: '0 1px 4px rgba(0, 0, 0, 0.08)',
    /** The design system's `paper/elevation-2` — a menu surface. */
    menu: '0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)',
  },
  navigation: {
    muted: '#ddd5e9',
    feedback: '#c8e3fe',
  },
  workflow: {
    green: '#87ff4b',
    greenMuted: '#dff5e4',
    greenBorder: '#a9d9a0',
    pink: workflowPink,
    pinkMuted: 'rgba(229, 50, 132, 0.2)',
    purple: peritasviolet,
    purpleMuted: 'rgba(144, 29, 228, 0.2)',
    yellow: '#d4dd2a',
    yellowMuted: 'rgba(242, 255, 3, 0.3)',
    yellowAlt: '#f2ff03',
    surgicalIcon: 'rgba(70, 82, 226, 0.2)',
    critical: workflowPink,
    standard: '#ff933b',
    success: '#17885E',
    flexible: peritasgrey[200],
    confirmation: '#d3d9e2',
    statusSurface: '#f5f5f5',
    tableDivider: 'rgba(18, 27, 42, 0.1)',
  },
  peritasblue: {
    50: '#e1f7fe',
    100: '#b5ebfc',
    200: '#85def9',
    300: '#54d0f4',
    400: '#32c6ee',
    500: '#23bde8',
    600: '#1badd3',
    700: '#0d98b8',
    800: '#00859f',
    900: '#006579',
    a100: '#6cf8ff',
    a200: '#00ebf7',
    a400: '#00dee9',
    a700: '#00d2dd',
  },
  peritasgrey,
  peritasred: {
    50: '#feebee',
    100: '#ffcdd0',
    200: '#ff9a9e',
    300: '#ff676d',
    400: '#ff4047',
    500: '#ff4047',
    600: '#f44336',
    650: '#dc2626',
    700: '#cc2f36',
    800: '#b3262c',
    900: '#991d22',
    a100: '#ff9a9e',
    a200: '#ff676d',
    a400: '#ff4047',
    a700: '#cc2f36',
  },
};

export default periversePalette;
